import React, { useState, useEffect, useRef } from 'react';
import './MenuSection.css';
import ClubMenuCards from './ClubMenuCards';
import Package from './Package';
import Event from './Event';
import Gallery from './Gallery';
import Teaser from './Teaser';
import PartyPackageMenu from './PartyPackageMenu';
import AboutvenueDetails from './AboutvenueDetails';

export default function MenuSection({ partypackages, events, gallery, teasers, menus, isPartyPackage, isvenue }) {
    const [activeTab, setActiveTab] = useState('Menu');
    const sectionRefs = useRef({});

    const tabs1 = ['Menu', 'Package', 'Event', 'Gallery', 'Teaser', "About"];
    const tabs2 = ['Menu', 'Event', 'Teaser'];

    const tabs = !isPartyPackage ? tabs1 : tabs2

    // Map tab names to section IDs
    const idMap = {
        'Menu': 'club-menu-section',
        'Package': 'vcdp-package-section',
        'Event': 'vcdp-event-section',
        'Gallery': 'vcdp-gallery-section',
        'Teaser': 'vcdp-teaser-section',
        "About": 'vcdp-about-section'
    };

    useEffect(() => {
        const observerOptions = {
            root: null,
            threshold: Array.from({ length: 101 }, (_, i) => i / 100),
        };

        let visibleSections = {};

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const id = entry.target.id;
                visibleSections[id] = entry;
            });

            const topSection = Object.values(visibleSections)
                .filter(entry => entry.isIntersecting)
                .sort((a, b) => {
                    const aTop = Math.abs(a.boundingClientRect.top);
                    const bTop = Math.abs(b.boundingClientRect.top);
                    return aTop - bTop;
                })[0];

            if (topSection) {
                const id = topSection.target.id;
                const newTab = Object.keys(idMap).find((key) => idMap[key] === id);
                if (newTab && newTab !== activeTab) {
                    setActiveTab(newTab);
                }
            }
        }, observerOptions);

        Object.values(idMap).forEach((id) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [activeTab]);




    return (
        <div className='vcdp-MenuSection'>
            <div className="vcdp-container">
                {/* Tab Navbar */}
                <div className="vcdp-sec-navbar">
                    <div className="vcdp-list-menu-tab">
                        <ul>
                            {tabs.map((tab) => (
                                <li
                                    key={tab}
                                    className={activeTab === tab ? 'vcdp-active' : ''}
                                    onClick={() => {
                                        setActiveTab(tab);
                                        const targetElement = document.getElementById(idMap[tab]);
                                        if (targetElement) {
                                            const offset = -140;
                                            const topPos = targetElement.getBoundingClientRect().top + window.scrollY + offset;
                                            window.scrollTo({ top: topPos, behavior: 'smooth' });
                                        }
                                    }}
                                >
                                    <span>{tab}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Sections */}
                {isPartyPackage ? (
                    <div className='club-menu-section' id='club-menu-section'>
                        <PartyPackageMenu menus={menus} />
                    </div>
                ) : (
                    <div className='club-menu-section' id='club-menu-section'>
                        <ClubMenuCards menus={menus} />
                    </div>
                )}

                {!isPartyPackage &&
                    <div className='vcdp-package-section' id='vcdp-package-section'>
                        <Package partypackages={partypackages} />
                    </div>
                }

                <div className='vcdp-event-section' id='vcdp-event-section'>
                    <Event events={events} />
                </div>
                {!isPartyPackage &&
                    <div className='vcdp-gallery-section' id='vcdp-gallery-section'>
                        <Gallery gallery={gallery} />
                    </div>
                }
                <div className='vcdp-teaser-section' id='vcdp-teaser-section'>
                    <Teaser teasers={teasers} />
                </div>
                <div className='vcdp-about-section' id='vcdp-about-section'>
                    <AboutvenueDetails  />
                </div>
            </div>
        </div>
    );
}
